export const baseURL = "https://admin.ajobfun.store/";
export const key = "BS67Rfb0Tf";
